import type { Messages } from '@/types'

const messages: Messages = {
    common: {
        actions: {
            add: 'Добавить',
            edit: 'Редактировать',
            delete: 'Удалить',
            cancel: 'Отмена',
            back: 'Назад',
            save: 'Сохранить',
            update: 'Обновить',
            reset: 'Сбросить',
            refresh: 'Обновить',
            backToList: '@:common.back к списку',
            resetDefaults: '@:common.reset к значениям по умолчанию',
            confirm: 'Подтвердить',
            proceed: 'Продолжить',
            close: 'Закрыть',
            apply: 'Применить',
            search: 'Поиск',
            filter: 'Фильтр',
            clear: 'Очистить',
            select: 'Выбрать',
            upload: 'Загрузить',
            download: 'Скачать',
            view: 'Просмотр',
            sort: 'Сортировать',
            seeMore: 'Смотреть больше'
        },
        status: {
            success: 'Успех',
            error: 'Ошибка',
            loading: 'Загрузка...'
        },
        messages: {
            deleteConfirm: 'Вы уверены, что хотите удалить этого пользователя?',
            generalError: 'Что-то пошло не так! Пожалуйста, попробуйте снова',
            addSuccess: 'Запись успешно добавлена!',
            updateSuccess: 'Запись успешно обновлена!',
        },
        placeholder: {
            avatar: '?'
        },
        labels: {
            loading: 'Загрузка',
            noResults: 'Результаты не найдены',
            noData: 'Нет доступных данных',
            selected: 'Выбрано',
            required: 'Обязательно',
            optional: 'Необязательно',
            search: 'Поиск...',
            filter: 'Фильтр...',
            from: 'От',
            to: 'До',
            date: 'Дата',
            status: 'Статус',
            item: 'Элемент {index}',
            addItem: 'Добавить элемент',
            removeItem: 'Удалить элемент',
            skipToMain: 'Перейти к основному содержимому',
            openNavigation: 'Открыть навигацию',
            closeNavigation: 'Закрыть навигацию',
            mainNavigation: 'Основная навигация',
            moveUp: 'Переместить вверх',
            moveDown: 'Переместить вниз',
            and: 'и'
        },
        errors: {
            upload: 'Не удалось загрузить файл',
            download: 'Не удалось скачать файл',
            generic: 'Произошла ошибка',
            notFound: 'Не найдено',
            unauthorized: 'Несанкционированный доступ',
            validation: 'Пожалуйста, проверьте ввод'
        },
        validation: {
            required: 'Это поле обязательно',
            email: 'Неверный адрес электронной почты',
            minLength: 'Минимальная длина {length}',
            maxLength: 'Максимальная длина {length}',
            min: 'Минимальное значение {min}',
            max: 'Максимальное значение {max}',
            matches: 'Неверный формат',
            unique: 'Значение должно быть уникальным',
            confirm: 'Пароли не совпадают'
        }
    },
    pages: {
        users: {
            title: 'Пользователи',
            description: 'Управление пользователями системы',
            actions: {
                invite: 'Пригласить пользователя',
                resetPassword: 'Сбросить пароль'
            }
        },
        settings: {
            title: 'Настройки',
            actions: {
                resetDefaults: 'Сбросить к значениям по умолчанию'
            }
        },
        reports: {
            title: 'Отчеты',
            description: 'Генерировать и скачивать отчеты',
            actions: {
                generateReport: 'Создать отчет',
                downloadCsv: 'Скачать CSV',
                startDate: 'Дата начала',
                endDate: 'Дата окончания',
                apps: 'Приложения',
            },
            error: {
                generation: 'Не удалось создать отчет',
                download: 'Не удалось скачать отчет'
            }
        }
    },
    navigation: {
        home: 'Главная',
        library: 'Библиотека',
        search: 'Поиск',
        login: 'Войти',
        signInToGetPremium: 'Получить Premium',
        subscribe: 'Подписаться',
        support: 'Поддержка',
        settings: 'Настройки',
        logout: 'Выйти'
    },
    settings: {
        title: 'Настройки',
        description: 'Управляйте настройками аккаунта, предпочтениями и информацией профиля.',
        sections: 'Разделы настроек',
        menu: {
            profile: 'Профиль',
            account: 'Аккаунт',
            general: 'Общие',
            purchases: 'Покупки',
            activity: 'Активность'
        },
        profile: {
            title: 'Профиль',
            changeImage: 'Изменить изображение',
            updateProfile: 'Обновить профиль',
            changePassword: 'Изменить пароль',
            updatePassword: 'Обновить пароль',
            fields: {
                fullName: 'Полное имя',
                emailAddress: 'Адрес электронной почты',
                dateOfBirth: 'Дата рождения',
                currentPassword: 'Текущий пароль',
                newPassword: 'Новый пароль',
                confirmNewPassword: 'Подтвердить новый пароль'
            },
            toasts: {
                imageUpdated: 'Изображение обновлено',
                imageUpdatedMessage: 'Изображение вашего профиля успешно обновлено',
                uploadFailed: 'Загрузка не удалась',
                profileUpdated: 'Профиль обновлен',
                profileUpdatedMessage: 'Ваш профиль успешно обновлен',
                passwordUpdated: 'Пароль обновлен',
                passwordUpdatedMessage: 'Ваш пароль успешно обновлен',
                passwordError: 'Ошибка пароля',
                passwordMismatch: 'Пароли не совпадают',
                passwordTooWeak: 'Пароль слишком слабый'
            }
        },
        account: {
            title: 'Аккаунт',
            accountInformation: 'Информация об аккаунте',
            emailAddress: 'Адрес электронной почты',
            memberSince: 'Участник с',
            redeemPromoCode: 'Использовать промокод',
            redeemPromoCodeDescription: 'Есть промо- или подарочный код? Введите его здесь, чтобы применить к аккаунту или следующей подписке.',
            subscription: {
                title: 'Подписка',
                currentPlan: 'Текущий план',
                premiumSubscription: 'Премиум подписка',
                nextRenewal: 'Следующее продление:',
                accessUntil: 'Доступ до:',
                manageInAppStore: 'Ваша подписка была оформлена через App Store. Чтобы отменить или изменить её, откройте «Подписки» в настройках Apple ID на устройстве, с которого вы оформили подписку.',
                manageInPlayStore: 'Ваша подписка была оформлена через Google Play. Чтобы отменить или изменить её, откройте «Подписки» в Google Play Store на устройстве, с которого вы оформили подписку.',
                notSubscribed: 'В настоящее время вы не подписаны ни на один план.',
                subscribeNow: 'Подписаться сейчас',
                findOutMore: 'Узнать больше',
                cancelSubscription: 'Отменить подписку',
                cancelSubscriptionTitle: 'Отменить подписку',
                cancelSubscriptionMessage: 'Вы уверены, что хотите отменить подписку? Вы потеряете доступ к премиум контенту в конце текущего расчетного периода.',
                keepSubscription: 'Сохранить подписку',
                toasts: {
                    subscriptionActivated: 'Подписка активирована',
                    subscriptionActivatedMessage: 'Добро пожаловать в Premium!',
                    subscriptionFailed: 'Подписка не удалась',
                    paymentMethodUpdated: 'Способ оплаты обновлен',
                    paymentMethodUpdatedMessage: 'Ваша платежная информация успешно обновлена',
                    subscriptionCancelled: 'Подписка отменена',
                    subscriptionCancelledMessage: 'Ваша подписка закончится в текущем расчетном периоде',
                    cancellationFailed: 'Отмена не удалась'
                }
            },
            closeAccount: {
                title: 'Закрыть аккаунт',
                requestDescription: 'Запросить постоянное закрытие вашего аккаунта. Это действие нельзя отменить.',
                requestButton: 'Запросить закрытие аккаунта',
                confirmationTitle: 'Вы уверены, что хотите деактивировать свой аккаунт? Это приведет к:',
                confirmationItems: {
                    cancelSubscription: 'Отмене вашей активной подписки (если есть)',
                    removeCommunications: 'Удалению вас из всех коммуникаций',
                    scheduleDeletion: 'Запланированию постоянного удаления ваших данных через 30 дней'
                },
                confirmationWarning: 'Вы можете отменить запрос на деактивацию в любое время в течение 30 дней. После этого периода ваш аккаунт и все связанные данные будут удалены навсегда.',
                confirmationCheckbox: 'Я понимаю, что мой аккаунт будет удален навсегда через 30 дней',
                deactivateAccount: 'Деактивировать аккаунт',
                cancel: 'Отмена',
                scheduledTitle: 'Деактивация аккаунта запланирована',
                scheduledMessage: 'Ваш аккаунт запланирован к постоянному удалению',
                scheduledWarning: 'В течение этого периода вы не сможете войти в свой аккаунт. Если вы передумаете, вы можете отменить процесс деактивации.',
                cancelDeactivation: 'Отменить деактивацию аккаунта',
                toasts: {
                    deactivationRequested: 'Запрошена деактивация аккаунта',
                    deactivationRequestedMessage: 'Ваш аккаунт будет удален навсегда через 30 дней',
                    deactivationFailed: 'Деактивация не удалась',
                    deactivationCancelled: 'Деактивация отменена',
                    deactivationCancelledMessage: 'Ваш аккаунт больше не запланирован к удалению'
                }
            }
        },
        purchases: {
            title: 'История покупок',
            noPurchases: 'Покупки не найдены',
            invoice: 'Счет'
        },
        activity: {
            title: 'Временная шкала активности',
            dateRange: 'Диапазон дат',
            activityType: 'Тип активности',
            noActivities: 'Активности не найдены',
            resume: 'Продолжить',
            loadMore: 'Загрузить еще',
            filters: {
                last7Days: 'Последние 7 дней',
                last30Days: 'Последние 30 дней',
                lastYear: 'Прошлый год',
                allTime: 'Все время',
                allActivities: 'Все активности',
                listening: 'Прослушивание',
                purchases: 'Покупки',
                likes: 'Нравится',
                bookmarks: 'Закладки'
            },
            types: {
                listenedTo: 'Прослушано {title}',
                purchased: 'Куплено {title}',
                liked: 'Понравилось {title}',
                bookmarked: 'В закладках {title}'
            }
        },
        appSettings: {
            title: 'Настройки приложения',
            darkMode: 'Темный режим',
            language: 'Язык',
            languageOptions: {
                english: 'Английский',
                spanish: 'Испанский',
                french: 'Французский',
                german: 'Немецкий',
                italian: 'Итальянский',
                portuguese: 'Португальский',
                dutch: 'Голландский',
                slovak: 'Словацкий',
                russian: 'Русский',
                arabic: 'العربية'
            }
        },
        notifications: {
            title: 'Уведомления',
            emailNotifications: 'Email уведомления',
            emailNotificationsHint: 'Получать обновления по электронной почте',
            pushNotifications: 'Push уведомления',
            pushNotificationsHint: 'Получать push уведомления',
            updatePreferences: 'Обновить предпочтения'
        },
        toasts: {
            themeUpdated: 'Тема обновлена',
            themeUpdatedMessage: 'Ваше предпочтение темы сохранено',
            languageUpdated: 'Язык обновлен',
            languageUpdatedMessage: 'Ваше языковое предпочтение сохранено',
            preferencesUpdated: 'Предпочтения обновлены',
            preferencesUpdatedMessage: 'Ваши предпочтения уведомлений сохранены',
            updateFailed: 'Обновление не удалось',
            updateFailedMessage: 'Не удалось обновить настройку',
            updateFailedNotificationMessage: 'Не удалось обновить предпочтения уведомлений'
        }
    },
    auth: {
        login: {
            title: 'Войти',
            description: 'Войдите в свой аккаунт Heard для доступа к библиотеке и премиум контенту',
            signIn: 'Войти',
            signInToAccount: 'Войдите в свой аккаунт',
            noAccount: 'Нет аккаунта?',
            signUp: 'Зарегистрироваться',
            continueAsGuest: 'Продолжить как гость',
            or: 'Или',
            agreeToTerms: 'Входя в систему, вы соглашаетесь с нашими',
            termsOfService: 'Условиями использования',
            privacyPolicy: 'Политикой конфиденциальности',
            forgotPassword: 'Забыли пароль?'
        },
        register: {
            title: 'Регистрация',
            description: 'Зарегистрируйтесь для аккаунта Heard, чтобы получить доступ к премиум аудио контенту, создать личную библиотеку и многое другое',
            createAccount: 'Создать аккаунт',
            createYourAccount: 'Создайте свой аккаунт',
            orSignIn: 'Или',
            signIn: 'войти',
            backToHome: 'Вернуться на главную',
            agreeToTerms: 'Создавая аккаунт, вы соглашаетесь с нашими',
            termsOfService: 'Условиями использования',
            privacyPolicy: 'Политикой конфиденциальности'
        },
        forms: {
            email: 'Адрес электронной почты',
            password: 'Пароль',
            confirmPassword: 'Подтвердить пароль',
            fullName: 'Полное имя',
            rememberMe: 'Запомнить меня',
            signIn: 'Войти',
            createAccount: 'Создать аккаунт'
        },
        toasts: {
            loginSuccess: 'Вход выполнен успешно',
            loginFailed: 'Вход не удался',
            registerSuccess: 'Аккаунт успешно создан',
            registerFailed: 'Регистрация не удалась'
        }
    },
    library: {
        title: 'Моя библиотека',
        description: 'Доступ к недавно воспроизведенным, понравившимся, купленным, в закладках и завершенным названиям в вашей личной библиотеке.',
        sections: 'Разделы библиотеки',
        noItems: 'В этом разделе нет элементов',
        sync: 'Синхронизировать библиотеку',
        tabs: {
            recent: 'Продолжить',
            liked: 'Избранное',
            purchased: 'Купленные',
            bookmarked: 'В закладках',
            finished: 'Слушать снова',
            finishedWatch: 'Смотреть снова',
            finishedRead: 'Читать снова'
        }
    },
    home: {
        title: 'Главная',
        error: {
            loadFailed: 'Не удалось загрузить контент'
        }
    },
    player: {
        chapters: 'Главы',
        options: 'Опции',
        playbackSpeed: 'Скорость воспроизведения',
        share: 'Поделиться',
        linkCopied: 'Ссылка скопирована',
        linkCopiedMessage: 'Ссылка для общего доступа скопирована в буфер обмена!',
        shareError: 'Ошибка общего доступа',
        shareErrorMessage: 'Не удалось скопировать ссылку для общего доступа. Пожалуйста, попробуйте снова.',
        bookmarkAdded: 'Успех',
        bookmarkAddedMessage: 'Закладка добавлена!',
        jumpedToBookmark: 'Успех',
        jumpedToBookmarkMessage: 'Переход к закладке!',
        likeError: 'Ошибка лайка',
        likeErrorMessage: 'Не удалось обновить статус лайка. Пожалуйста, попробуйте снова.',
        bookmarkError: 'Ошибка закладки',
        bookmarkErrorMessage: 'Не удалось обновить закладку. Пожалуйста, попробуйте снова.',
        favorites: {
            add: 'Добавить в избранное',
            remove: 'Удалить из избранного'
        },
        unknownChapter: 'Неизвестная глава',
        unknownTitle: 'Неизвестное название',
        unknownAuthor: 'Неизвестный автор'
    },
    details: {
        starring: 'В главных ролях:',
        author: 'Автор',
        narrator: 'Чтец',
        pause: 'Пауза',
        purchased: 'Куплено',
        continueReading: 'Продолжить чтение',
        continuePlaying: 'Продолжить воспроизведение',
        play: 'Воспроизвести',
        loading: 'Загрузка...',
        noChapters: 'Нет доступных глав',
        chapterFreeLabel: 'Бесплатно',
        listen: 'Слушать',
        purchaseSuccess: 'Покупка успешна',
        purchaseSuccessMessage: '{title} добавлен в вашу библиотеку',
        subscriptionSuccess: 'Подписка успешна',
        subscriptionSuccessMessage: 'Добро пожаловать в Heard Premium!',
        subscriptionFailed: 'Подписка не удалась',
        subscriptionErrorMessage: 'Произошла ошибка при обработке вашей подписки.',
        info: 'Инфо',
        more: 'Ещё',
        episodes: 'Эпизоды',
        about: 'О произведении',
        series: 'Серия',
        producedBy: 'Произведено',
        recommendations: 'Вам также может понравиться',
        moreFromCategory: 'Ещё из {name}',
        moreFromAuthor: 'Ещё от {name}',
        moreFromCast: 'Ещё от {name}',
        moreFromSeries: 'Ещё из серии {name}',
        noRelated: 'Связанные названия пока недоступны.',
        ageVerification: {
            title: 'Только для взрослых',
            message: 'Этот контент предназначен только для взрослых. Подтвердите, что хотите продолжить.',
            minAgeHint: 'Вам должно быть не менее {age} лет, чтобы смотреть этот материал.',
            confirm: 'Я совершеннолетний, продолжить',
            cancel: 'Отмена',
            missingDobTitle: 'Требуется дата рождения',
            missingDobMessage: 'Укажите дату рождения в профиле, чтобы смотреть этот контент.',
            underageTitle: 'Возрастное ограничение',
            underageMessage: 'Вам должно быть не менее {age} лет, чтобы смотреть этот контент.',
        },
    },
    shareModal: {
        title: 'Поделиться',
        copyLink: 'Копировать ссылку',
        copyLinkWithMessage: 'Копировать ссылку с сообщением',
        copyLinkWithMessageHint: 'Включает название и описание',
        shareVia: 'Поделиться через...',
        shareViaHint: 'Приложения, сообщения, email',
        linkCopied: 'Ссылка скопирована',
        linkCopiedMessage: 'Ссылка скопирована в буфер обмена!',
        shared: 'Поделились',
        sharedMessage: 'Контент успешно отправлен'
    },
    contextMenu: {
        playFromBeginning: 'Воспроизвести с начала',
        markAsFinished: 'Отметить как завершенное',
        addToFavorites: 'Добавить в избранное',
        removeFromFavorites: 'Удалить из избранного',
        share: 'Поделиться',
        viewDetails: 'Просмотреть детали',
        removeFromLibrary: 'Удалить из библиотеки',
        continuePlaying: 'Продолжить воспроизведение',
        continueReading: 'Продолжить чтение'
    },
    actions: {
        subscribe: 'Подписаться',
        signInToGetPremium: 'Получить Premium',
        purchase: 'Купить',
        buy: 'Купить',
        buyFor: 'Купить за {price}',
        purchasedGoToLibrary: 'Куплено - Перейти в библиотеку',
        addToFavorites: 'Добавить в избранное',
        removeFromFavorites: 'Удалить из избранного',
        share: 'Поделиться'
    },
    browse: {
        sortBy: 'Сортировать по',
        sortOptions: {
            recent: 'Недавние',
            ascending: 'А-Я',
            descending: 'Я-А'
        }
    },

    legal: {
        companyNumber: 'Рег. номер',
        privacyPolicy: 'Политика конфиденциальности',
        termsOfService: 'Условия использования',
        agreeToTermsSubscribe: 'Подписываясь, вы соглашаетесь с нашими',
        operatedBy: '{appName} управляется {companyName}, {address}',
        faqs: 'FAQ'
    },
    support: {
        title: 'Поддержка',
        description: 'Нужна помощь с аккаунтом, подпиской или прослушиванием? Ознакомьтесь с FAQ и юридической информацией или свяжитесь с нами.',
        intro: 'Нужна помощь с аккаунтом, подпиской или прослушиванием? Ознакомьтесь с FAQ и юридической информацией ниже или свяжитесь с нами, если вам нужна дополнительная помощь.',
        quickLinks: 'Быстрые ссылки',
        contactTitle: 'Связаться с поддержкой',
        contactDescription: 'Отправьте сообщение нашей команде поддержки. Сначала проверьте FAQ для быстрых ответов.',
        contactIntro: 'Если вам нужна помощь, мы здесь для вас. На многие распространённые вопросы уже есть ответы в нашем справочном центре.',
        contactIntroFaqBefore: 'Пожалуйста, ознакомьтесь с нашими ',
        contactIntroFaqAfter: ' для ответов на распространённые вопросы. Если вам всё ещё нужна помощь, заполните форму, и мы свяжемся с вами как можно скорее.',
        contactSubmit: 'Отправить сообщение',
        contactName: 'Имя',
        contactEmail: 'Email',
        contactSubject: 'Тема',
        contactMessage: 'Сообщение',
        contactMessageHint: 'Опишите проблему подробно',
        backToSupport: 'Назад в поддержку',
        pageLoading: 'Загрузка…',
        pageNotAvailable: 'Эта страница сейчас недоступна.',
        unsupportedSection: 'Неподдерживаемый раздел контента: {name}',
        useContactFormBefore: 'Нужно связаться с нами? Используйте нашу ',
        contactSuccessTitle: 'Сообщение отправлено',
        contactSuccessMessage: 'Ваше сообщение отправлено. Мы свяжемся с вами в ближайшее время.',
        contactErrorTitle: 'Ошибка отправки',
        contactErrorMessage: 'Не удалось отправить сообщение. Попробуйте еще раз.'
    },
    promo: {
        haveCode: 'Есть промокод?',
        placeholder: 'Введите код',
        apply: 'Применить',
        remove: 'Удалить',
        applied: '{name} – {discount}',
        invalidCode: 'Недействительный или просроченный код.',
        expired: 'Срок действия кода истёк.',
        notValidForPurchase: 'Этот код не действует для данной покупки.',
        free: 'Бесплатно',
        percentOff: 'Скидка {value}%',
        fixedOff: 'Скидка {value}',
        useWhenSubscribe: 'Используйте это предложение при подписке ниже.',
        useWhenPurchase: 'Используйте этот код при покупке заголовка.',
        accessGranted: 'Доступ применён к вашему аккаунту.'
    }
}

export default messages

